<template>
  <div class="d-g flex-b-c">
    <div class="dg-t-l">
      <div class="dg-t-l-d flex-a-c">
        <ShouDatePicker @changePicker="changePicker" />
      </div>
      <div class="dg-t-l-l">

        <el-table :data="polyline" style="width: 100%" height="100%">
          <el-table-column prop="create_time" label="时间" width="180">
          </el-table-column>
          <el-table-column label="位置" width="180">
            <div slot-scope="scope">
              <!-- <div>{{ scope.row.E }}</div>
              <div>{{ scope.row.N }}</div> -->
              <div>
                {{ gpsSwitch(scope.row.E, scope.row.N) }}

              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="dg-c-m">
      <div class="dg-c-m-c flex-b-c">
        <div class="flex-b-c">
          <el-switch v-model="isOpen" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
          <span style="margin-left:8px">运动轨迹已{{ isOpen ? '开启' : '关闭' }}</span>
        </div>
        <div class="flex-b-c">
          <span>当前位置</span>
          <i class="el-icon-refresh icon" style="font-size:18px;color: #13CE66;cursor: pointer;"
            @click="getLatiLongi"></i>
          <div style="width: 240px; margin-left: 8px;">
            {{ address || "未获取到实时位置" }}</div>
        </div>
      </div>
      <div class="dg-c-m-m">
        <div id="map_gps" style="width: 100%; height: 100%;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import ShouDatePicker from '@/components/basics/ShouDatePicker'
import AMapLoader from '@amap/amap-jsapi-loader';
// import gps from '@/assets/scripts/gps.js';
import gpsConversion from '@/assets/scripts/gpsConversion.js';

export default {
  name: "DeviceGps",
  props: {
    currentDetail: {
      type: Object
    }
  },
  components: {
    ShouDatePicker
  },
  beforeDestroy() {
    clearInterval(this.IntervalId);
  },
  computed: {
    myWebSocket() {
      return this.$store.getters.myWebSocket;
    },
  },
  data() {
    return {
      dateValue: '',
      isOpen: false,
      AMap: null,
      IntervalId: null,
      address: '',
      polyline: [],
    }
  },
  mounted() {
    this.initSocket();
    this.getPolyline(new Date());
    this.getLatiLongi();
  },
  methods: {
    gpsSwitch(E, N) {
      const { lat, lon } = gpsConversion(`N${N}`, `E${E}`, true);
      return [lon.toFixed(6), lat.toFixed(6)].join(',');
    },
    getLatiLongi() {
      this.sendCmd([{ type: "invoke_method", data: { methodName: "getLatiLongi", methodParams: {} } }], "get");
    },
    getPolyline(today) {
      if (!today) { return; }
      // 定义轨迹点的经纬度
      const { start_time, end_time } = this.getTime(today);
      this.$http.post("/admin/device/getPolyline", {
        start_time,
        end_time,
        sn: this.currentDetail.sn
      }, (res) => {
        this.polyline = res;
        const points = res.map((item) => {
          const { E, N } = item;
          const { lat, lon } = gpsConversion(`N${N}`, `E${E}`);
          return [lon, lat];
        });
        this.initPolyline(points);
      });
    },
    getTime(today) {
      return {
        start_time: new Date(new Date(today).setHours(0, 0, 0, 0)).toLocaleString(),
        end_time: new Date(new Date(today).setHours(23, 59, 59, 999)).toLocaleString()
      }
    },
    changePicker(today) {
      this.getPolyline(today);
    },
    geocoder(lat, lon) {
      // console.log(lat, lon);
      if (!this.AMap) {
        return;
      }
      const geocoder = new this.AMap.Geocoder();
      geocoder.getAddress([lon, lat], (status, result) => {
        if (status === 'complete' && result.info === 'OK') {
          const address = result.regeocode.formattedAddress; // 获取地址名称
          // console.log('地址名称:', address);
          this.address = address;
        } else {
          console.error('获取地址失败:', result);
        }
      });
    },
    initPolyline(points) {
      AMapLoader.load({
        key: 'ba31d341e2b5184d678f1a550cc6b5d9', // 请替换为你的高德地图API密钥
        version: '1.4.15',
        plugins: ['AMap.Geocoder']
      }).then(AMap => {
        this.AMap = AMap;
        // 初始化地图
        const map = new AMap.Map('map_gps', {
          center: points[0], // 中心点经纬度
          zoom: 10, // 缩放级别
        });

        // 绘制轨迹
        const polyline = new AMap.Polyline({
          path: points, // 轨迹点的经纬度数组
          strokeColor: '#FF0000', // 轨迹线颜色
          strokeWeight: 5, // 轨迹线宽度
          strokeOpacity: 1, // 轨迹线透明度
        });
        // 将轨迹添加到地图
        polyline.setMap(map);

        let marker = new AMap.Marker({ position: points[0], });
        marker.setMap(map);
        marker = new AMap.Marker({ position: points[points.length - 1], });
        marker.setMap(map);

      }).catch(e => {
        console.error(e);
      });
    },
    sendCmd(commands_info, type = "set") {
      const { id, sn, type_id, name } = this.currentDetail;
      let devices_info = [{ id, sn, type_id, name, cache: {} }];
      this.$http.post("/admin/Command/generalCommand", {
        device_select_mode: "multiple",
        devices_info: encodeURIComponent(JSON.stringify(devices_info)),
        commands_info: encodeURIComponent(JSON.stringify(commands_info)),
        request_type: type
      }, () => {
        // console.log(res);
      });
    },
    initSocket() {
      this.myWebSocket.onmessage = (val) => {
        const { sn: infoSN } = this.currentDetail;
        const { type, data, sn } = JSON.parse(val.data);
        if (infoSN != sn) { return false; }
        switch (type) {
          case "invoke_method": {
            const uri = data.uri;
            const res = JSON.parse(data.response);
            switch (uri) {
              case "getLatiLongi": {
                const [N, E] = res.data
                // const N1 = N.substring(1, 3);
                // const N2 = N.substring(3);
                // const E1 = E.substring(1, 4);
                // const E2 = E.substring(4);
                // const { lat, lon } = gps.gcj_encrypt(Number(N1) + parseFloat((Number(N2) / 60).toFixed(8)), Number(E1) + parseFloat((Number(E2) / 60).toFixed(8)));
                const { lat, lon } = gpsConversion(N, E);
                this.geocoder(lat, lon);
              } break;
              default:
                break;
            }
          } break;
          default:
            break;
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.d-g {
  width: 100%;
  height: 100%;
  background: #edfbff;

  .dg-t-l {
    width: 340px;
    height: 100%;
    background: #fff;

    .dg-t-l-d {
      padding: 8px 0px;
    }

    .dg-t-l-l {
      height: calc(100% - 360px);
    }
  }

  .dg-c-m {
    width: calc(100% - 340px - 8px);
    margin-left: 8px;
    height: 100%;
    background: #fff;

    .dg-c-m-c {
      height: 60px;
      padding: 0px 16px;
    }

    .dg-c-m-m {
      height: calc(100% - 60px);
      background: #ccf;
    }
  }
}
</style>